import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

interface TourGuideState {
  tourCompleted: boolean
  hasShown: boolean
  setTourCompleted: (completed: boolean) => void
  setHasShown: (shown: boolean) => void
  reset: () => void
}

export const useTourGuide = create<TourGuideState>()(
  persist(
    (set) => ({
      tourCompleted: false,
      hasShown: false,
      setTourCompleted: (completed) => set({ tourCompleted: completed }),
      setHasShown: (shown) => set({ hasShown: shown }),
      reset: () => set({ tourCompleted: false, hasShown: false })
    }),
    {
      name: "tour-guide-storage",
      storage: createJSONStorage(() => window.localStorage)
    }
  )
)
